<ul class="paginacao">
  <li (click)="selecionaPagina(1, $event)" [class.disabled]="paginaAtual === 1">
    <a href="" class="arrows" title="Ir para primeira pagina">&laquo;</a>
  </li>
  <li (click)="selecionaPagina(paginaAtual - 1, $event)" [class.disabled]="paginaAtual === 1">
    <a href="" class="arrows" title="Ir para pagina anterior">&lsaquo;</a>
  </li>
  <li class="disabled" (click)="cancelaEvento($event)" *ngIf="paginaAtual - range > 1">
    <a href="">...</a>
  </li>
  <li *ngFor="let pagina of paginas | async" [ngClass]="{ active: pagina === paginaAtual }" class="pagination-item">
    <a href="" (click)="selecionaPagina(pagina, $event)">
      {{ pagina }}
    </a>
  </li>
  <li class="disabled" (click)="cancelaEvento($event)" *ngIf="paginaAtual + range < totalPaginas">
    <a href="">...</a>
  </li>
  <li (click)="selecionaPagina(paginaAtual + 1, $event)" [class.disabled]="paginaAtual === totalPaginas">
    <a href="" class="arrows" title="Ir para a proxima página">&rsaquo;</a>
  </li>
  <li (click)="selecionaPagina(totalPaginas, $event)" [class.disabled]="paginaAtual === totalPaginas">
    <a href="" class="arrows" title="Ir para a última página">&raquo;</a>
  </li>
</ul>